import React, { useEffect, useState } from 'react';
import { Camera, Plus, Trash2, Edit } from 'lucide-react';
import { SERVIDOR } from './../../config';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ProductRegistration = () => {
  const navigate = useNavigate();
  const moldingTypes = [
    'Crowns',
    'Beds',
    'Coves',
    'Quarter Rounds',
    'Half Rounds',
    'Flat Astragals',
    'Base Caps',
    'Panel Mouldings',
    'Corner Guards',
    'Shingle/Panel Mouldings',
    'Battens',
    'Rounds',
    'Lattice',
    'Picture Moulding',
    'Casing',
    'Stops',
    'Otros'
  ];

  const [products, setProducts] = useState([
    {
      id: 1,
      image: 'https://via.placeholder.com/150',
      type: 'Crown Molding',
      number: 'WM-CRN-001',
      descriptionEn: 'Classic oak wood crown molding'
    },
    {
      id: 2,
      image: 'https://via.placeholder.com/150',
      type: 'Cove Molding',
      number: 'WM-CVE-002',
      descriptionEn: 'Soft cove molding for interior finishes'
    }
  ]);

  const [currentProduct, setCurrentProduct] = useState({
    id: null,
    image: null,
    type: '',
    number: '',
    descriptionEn: ''
  });

  const [isEditing, setIsEditing] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [otherType, setOtherType] = useState('');

  useEffect(() => {
    validarAdmin();
  }, []);

  const validarAdmin = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(SERVIDOR + '/api/validar-admin', {
        adminToken: token
      });
      const data = response.data;
      
      if (!data.ok) {
        alert('Acceso denegado');
        navigate('/loginAdmin');
      } else {
        fetchProducts();

      }


    } catch (error) {
      console.error('Error validating admin:', error);
      alert('Error de autenticación');
      navigate('/loginAdmin');
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await fetch(SERVIDOR + '/api/v2');
      const data = await response.json();
      setProducts(data.arreglo);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentProduct(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'type' && value !== '_Otros') {
      setOtherType('');
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCurrentProduct(prevState => ({
          ...prevState,
          image: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await agregarProducto();
    let moldingNumber = currentProduct.moldingNumber;
    let description = currentProduct.description;
    let category = currentProduct.category;
    const finalProduct = {
      ...currentProduct,
      type: category,
      descriptionEn: description,
      number: moldingNumber
    };

    if (isEditing) {
      setProducts(products.map(prod => 
        prod.id === finalProduct.id ? finalProduct : prod
      ));
    } else {
      const newProduct = {
        ...finalProduct,
        id: products.length + 1
      };
      setProducts([...products, newProduct]);
    }

    setCurrentProduct({
      id: null,
      image: null,
      type: '',
      number: '',
      descriptionEn: ''
    });
    setOtherType('');
    setIsEditing(false);
    setShowForm(false);
  };

  const agregarProducto = async () => {
    try {
      const imageFile = await dataURLtoFile(currentProduct.image, 'producto.jpg');
  
      const formData = new FormData();
      formData.append('moldingNumber', currentProduct.moldingNumber);
      formData.append('description', currentProduct.description);
      formData.append('imagen', imageFile);
      formData.append('category', currentProduct.category);

      const response = await fetch(SERVIDOR + '/api/nuevoProducto', {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error en la solicitud: ${errorText}`);
      }
      
      const result = await response.json();
      
    } catch (error) {
      console.error('Error al hacer la solicitud:', error);
      alert('Error al guardar el producto');
    }
  };
  
  const dataURLtoFile = async (dataurl, filename) => {
    const response = await fetch(dataurl);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
  };

  const handleEdit = (product) => {
    if (moldingTypes.includes(product.type)) {
      setCurrentProduct(product);
    } else {
      setCurrentProduct({...product, type: 'Otros'});
      setOtherType(product.type);
    }
    setIsEditing(true);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    fetch(SERVIDOR+'/api/producto/'+id, {
      method: 'delete'
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      alert('Producto eliminado correctamente');
    })
    .then(() => {
      setProducts(products.filter(prod => prod.id !== id));
    })
    .catch(error => {
      console.error('Error:', error);
    });
  };

  return (
    <div className="p-6 bg-gradient-to-br from-gray-100 to-gray-200 min-h-screen mt-16">
      <div className="max-w-5xl mx-auto bg-white shadow-2xl rounded-xl overflow-hidden">
        <div className="bg-[#697565] text-white p-6 flex justify-between items-center">
          <h2 className="text-3xl font-bold">Wood Molding Management</h2>
        </div>

        <div className="p-6">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse rounded-lg overflow-hidden shadow-md">
              <thead>
                <tr className="bg-[#697565] text-white">
                  <th className="p-3 text-left">Image</th>
                  <th className="p-3 text-left">Molding Type</th>
                  <th className="p-3 text-left">Number</th>
                  <th className="p-3 text-left">Description</th>
                  <th className="p-3 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => (
                  <tr key={product.id} className="hover:bg-gray-50 border-b">
                    <td className="p-3">
                      <img 
                        src={product.image} 
                        alt="Molding" 
                        className="w-20 h-20 object-cover rounded-md"
                      />
                    </td>
                    <td className="p-3">{product.type}</td>
                    <td className="p-3">{product.number}</td>
                    <td className="p-3">{product.descriptionEn}</td>
                    <td className="p-3 text-center">
                      <div className="flex justify-center space-x-2">
                        <button 
                          type='button'
                          onClick={() => handleDelete(product.id)}
                          className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded"
                        >
                          <Trash2 size={20} alt="Eliminar" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="p-6 text-center">
          <button 
            onClick={() => setShowForm(!showForm)}
            className="bg-[#697565] text-white px-6 py-3 rounded-lg hover:bg-opacity-90 transition-colors flex items-center justify-center mx-auto"
          >
            <Plus className="mr-2" size={24} />
            {showForm ? 'Hide Form' : 'Add New Molding'}
          </button>
        </div>

        {showForm && (
          <div className="p-6 bg-gray-100">
            <div className="max-w-2xl mx-auto bg-white shadow-xl rounded-xl overflow-hidden">
              <div className="bg-[#697565] text-white p-4 flex justify-between items-center">
                <h3 className="text-2xl font-semibold">
                  {isEditing ? 'Edit Molding' : 'Register New Molding'}
                </h3>
              </div>
              <form onSubmit={handleSubmit} className="p-6 space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block mb-3 text-lg font-semibold">Molding Image</label>
                    <div className="flex items-center">
                      <input 
                        type="file"
                        name="imagen" 
                        accept="image/*" 
                        onChange={handleImageUpload}
                        className="hidden" 
                        id="imageUpload"
                      />
                      <label 
                        htmlFor="imageUpload" 
                        className="cursor-pointer flex items-center justify-center w-full h-64 border-2 border-dashed border-gray-300 rounded-lg hover:border-[#697565] transition-all"
                      >
                        {currentProduct.image ? (
                          <img 
                            src={currentProduct.image} 
                            alt="Preview" 
                            className="max-h-full max-w-full object-contain rounded-lg"
                          />
                        ) : (
                          <div className="text-gray-500 flex flex-col items-center">
                            <Camera size={64} className="mb-4 opacity-70" />
                            <span className="text-lg">Upload Image</span>
                          </div>
                        )}
                      </label>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div>
                      <label className="block mb-2 text-lg font-semibold">Molding Type</label>
                      <select
                        name="category"
                        value={currentProduct.category}
                        onChange={handleInputChange}
                        className="w-full p-3 rounded border border-gray-300 focus:ring-2 focus:ring-[#697565]/50 transition-all"
                        required
                      >
                        <option value="">Select type</option>
                        {moldingTypes.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                      {currentProduct.type === 'Otros' && (
                        <input
                          type="text"
                          value={otherType}
                          onChange={(e) => setOtherType(e.target.value)}
                          className="mt-2 w-full p-3 rounded border border-gray-300 focus:ring-2 focus:ring-[#697565]/50 transition-all"
                          placeholder="Specify other molding type"
                          required
                        />
                      )}
                    </div>

                    <div>
                      <label className="block mb-2 text-lg font-semibold">Molding Number</label>
                      <input
                        type="text"
                        name="moldingNumber"
                        value={currentProduct.moldingNumber}
                        onChange={handleInputChange}
                        className="w-full p-3 rounded border border-gray-300 focus:ring-2 focus:ring-[#697565]/50 transition-all"
                        placeholder="E.g. WM-CRN-001"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <label className="block mb-2 text-lg font-semibold">Description</label>
                  <textarea
                    name="description"
                    value={currentProduct.description}
                    onChange={handleInputChange}
                    className="w-full p-3 rounded border border-gray-300 focus:ring-2 focus:ring-[#697565]/50 transition-all"
                    rows="4"
                    placeholder="Enter description"
                    required
                  />
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="bg-[#697565] text-white px-6 py-3 rounded-lg hover:bg-opacity-90 transition-colors"
                  >
                    {isEditing ? 'Update Molding' : 'Register Molding'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductRegistration;